
export const CONFIRMED_CREATE_DEPARTMENT_ACTION = "CONFIRMED_CREATE_DEPARTMENT_ACTION";
export const CONFIRMED_DELETE_DEPARTMENT_ACTION = "CONFIRMED_DELETE_DEPARTMENT_ACTION";
export const CONFIRMED_EDIT_DEPARTMENT_ACTION = "CONFIRMED_EDIT_DEPARTMENT_ACTION";
export const CONFIRMED_GET_DEPARTMENTS = "CONFIRMED_GET_DEPARTMENTS";
